import {configureStore} from '@reduxjs/toolkit';
import snackbarSlice from './components/Snackbar/slice';

export const store = configureStore({
  reducer: {
    [snackbarSlice.name]: snackbarSlice.reducer
  }
});
